module.exports = __webpack_public_path__ + "static/media/download.ab2c31ae.svg";